import { ColorVariant, Size, Variant } from './interfaces';
import styles from './SimpleCounter.module.scss';

export const SIZE: Record<Size, Size> = {
  M: 'M',
  L: 'L',
  XL: 'XL',
};

export const VARIANT: Record<Variant, Variant> = {
  primary: 'primary',
  secondary: 'secondary',
};

export const COLOR_VARIANT: Record<ColorVariant, ColorVariant> = {
  default: 'default',
  inverse: 'inverse',
  outlined: 'outlined',
};

export const SizeMap = new Map([
  [SIZE.M, styles.sizeM],
  [SIZE.L, styles.sizeL],
  [SIZE.XL, styles.sizeXL],
]);

export const VariantMap = new Map([
  [VARIANT.primary, styles.primary],
  [VARIANT.secondary, styles.secondary],
]);

export const ColorVariantMap = new Map([
  [COLOR_VARIANT.default, styles.default],
  [COLOR_VARIANT.inverse, styles.inverse],
  [COLOR_VARIANT.outlined, styles.outlined],
]);
